import { render, staticRenderFns } from "./MetadataViewer.vue?vue&type=template&id=7a2f2af7&"
import script from "./MetadataViewer.vue?vue&type=script&lang=js&"
export * from "./MetadataViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports